import { slicedToArray as _slicedToArray, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { __rest, __awaiter } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { LazyLoad } from '../lazyLoad.mjs';
import { useParentScrollElement } from '../../hooks/useParentScrollElement.mjs';
import { BlurhashCanvas } from '../blurHash/index.mjs';
import { px2rem } from '../../helpers/rem.mjs';
import { isBrowser } from '../../helpers/envChecker/index.mjs';
import { SkeletonBox } from '../skeleton/index.mjs';
import { videoLoad, imageLoad } from './helpers.mjs';
import { isIOS } from '../../helpers/browserDetect.mjs';
import { BlurHash as BlurHash$1, Wrapper, Media, SkeletonContainer } from './styledComponents.mjs';

var BlurHash = BlurHash$1.withComponent(BlurhashCanvas);
function useMediaLazyTransition(_ref) {
  var _this = this;
  var type = _ref.type,
    src = _ref.src,
    srcSet = _ref.srcSet,
    sizes = _ref.sizes,
    onSuccess = _ref.onSuccess;
  var wrapperRef = React.useRef(null);
  var scrollElement = useParentScrollElement(wrapperRef);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVisible = _React$useState2[0],
    setVisible = _React$useState2[1];
  var _React$useState3 = React.useState(!isBrowser()),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoaded = _React$useState4[0],
    setLoaded = _React$useState4[1];
  var handleVisible = React.useCallback(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isIOS()) {
              _context.next = 4;
              break;
            }
            requestAnimationFrame(function () {
              setVisible(true);
              setLoaded(true);
            });
            if (onSuccess) {
              onSuccess();
            }
            return _context.abrupt("return");
          case 4:
            if (isLoaded) {
              _context.next = 22;
              break;
            }
            requestAnimationFrame(function () {
              setVisible(true);
            });
            _context.prev = 6;
            _context.t0 = type;
            _context.next = _context.t0 === "image" ? 10 : _context.t0 === "video" ? 13 : 16;
            break;
          case 10:
            _context.next = 12;
            return imageLoad(src, srcSet, sizes);
          case 12:
            return _context.abrupt("break", 16);
          case 13:
            _context.next = 15;
            return videoLoad(src);
          case 15:
            return _context.abrupt("break", 16);
          case 16:
            _context.prev = 16;
            requestAnimationFrame(function () {
              setLoaded(true);
            });
            if (onSuccess) {
              onSuccess();
            }
            return _context.finish(16);
          case 20:
            _context.next = 23;
            break;
          case 22:
            if (onSuccess) {
              onSuccess();
            }
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6,, 16, 20]]);
    }));
  }, [isLoaded, onSuccess, src, srcSet, sizes, type]);
  return {
    wrapperRef: wrapperRef,
    scrollElement: scrollElement,
    isLoaded: isLoaded,
    isVisible: isVisible,
    handleVisible: handleVisible
  };
}
function MediaLazyTransitionWrapper(props) {
  var children = props.children,
    blurHash = props.blurHash,
    previewColor = props.previewColor,
    width = props.width,
    height = props.height,
    src = props.src;
    props.type;
    var style = props.style,
    disableSkeleton = props.disableSkeleton,
    disableMediaOpacity = props.disableMediaOpacity,
    rest = __rest(props, ["children", "blurHash", "previewColor", "width", "height", "src", "type", "style", "disableSkeleton", "disableMediaOpacity"]);
  var _useMediaLazyTransiti = useMediaLazyTransition(props),
    wrapperRef = _useMediaLazyTransiti.wrapperRef,
    scrollElement = _useMediaLazyTransiti.scrollElement,
    isLoaded = _useMediaLazyTransiti.isLoaded,
    isVisible = _useMediaLazyTransiti.isVisible,
    handleVisible = _useMediaLazyTransiti.handleVisible;
  return jsxs(Wrapper, Object.assign({
    ref: wrapperRef,
    style: style
  }, rest, {
    children: [jsx(LazyLoad, {
      root: scrollElement,
      width: width,
      height: height,
      onVisible: handleVisible,
      children: jsx(Media, {
        transition: isVisible,
        disableMediaOpacity: disableMediaOpacity !== null && disableMediaOpacity !== void 0 ? disableMediaOpacity : false,
        mediaOpacity: Number(isLoaded),
        style: {
          opacity: Number(isLoaded)
        },
        children: children
      })
    }), !isLoaded && !disableSkeleton && !blurHash && jsx(SkeletonContainer, {
      children: jsx(SkeletonBox, {
        width: "100%",
        height: src ? px2rem(height) : "100%"
      })
    }), !isLoaded && (previewColor || blurHash) && jsx(SkeletonContainer, {
      children: jsx(BlurHash, {
        className: "placeholder",
        hash: blurHash,
        width: width,
        height: height,
        style: {
          backgroundColor: previewColor
        }
      })
    })]
  }));
}

export { MediaLazyTransitionWrapper };
